<template>
 <Layout title="" description="">
  <div class="container mx-auto p-6">
    <!-- Header -->
    <div class="flex items-center gap-4 mb-6">
      <button class="btn btn-outline d-flex align-items-center" @click="goBack">
        <ArrowLeft class="h-4 w-4 mr-2" />
        Back to Inventory
      </button>
      <div>
        <h1 class="text-3xl font-bold">{{ selectedItem.productName }} Management</h1>
        <p class="text-muted-foreground">
          Manage transactions and stock for {{ selectedItem.productName }}
        </p>
      </div>
    </div>

    <!-- Stats -->
    <div class="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
      <div class="border rounded-lg p-4">
        <div class="flex justify-between items-center mb-2">
          <span class="text-sm font-medium">Total Items</span>
          <Package class="h-4 w-4 text-gray-400" />
        </div>
        <div class="text-2xl font-bold">{{ selectedItem.totalCount }}</div>
      </div>

      <div class="border rounded-lg p-4">
        <div class="flex justify-between items-center mb-2">
            <span class="text-sm font-medium">
            {{ (selectedItem.totalCount - selectedItem.onHoldCount) >= 0 ? 'Free Stock' : 'Shortage' }}
            </span>
            <CheckCircle
            class="h-4 w-4"
            :class="(selectedItem.totalCount - selectedItem.onHoldCount) >= 0 ? 'text-green-600' : 'text-red-600'"
            />
        </div>
        <div
            class="text-2xl font-bold"
            :class="(selectedItem.totalCount - selectedItem.onHoldCount) >= 0 ? 'text-green-600' : 'text-red-600'"
        >
            {{ selectedItem.totalCount - selectedItem.onHoldCount }}
        </div>
      </div>



      <div class="border rounded-lg p-4">
        <div class="flex justify-between items-center mb-2">
          <span class="text-sm font-medium">Allocation</span>
          <Clock class="h-4 w-4 text-yellow-600" />
        </div>
        <div class="text-2xl font-bold text-yellow-600">
          {{ selectedItem.onHoldCount }}
        </div>
      </div>

    </div>
<!--     
    <div class="overflow-x-auto">
        <div class="d-flex gap-2 mb-2 flex-nowrap" style="min-width: max-content;">
            <button
            class="btn px-3 py-1 rounded-pill fw-semibold"
            :class="tab === 'transaction' ? 'bg-white shadow-sm border' : 'bg-light text-muted border-0'"
            @click="tab = 'transaction'"
            >
            Transaction
            </button>

            <button
            class="btn px-3 py-1 rounded-pill fw-semibold"
            :class="tab === 'serial' ? 'bg-white shadow-sm border' : 'bg-light text-muted border-0'"
            @click="tab = 'serial'"
            >
            Serial Number
            </button>
        </div>
    </div>
     -->
    <!-- Transaction Modal -->
    <div v-if="isTxnDialogOpen" class="modal fade show d-block" tabindex="-1">
        <div class="modal-dialog modal-md">
            <div class="modal-content">
            <form @submit.prevent="createTransaction">
                <div class="modal-header">
                <h5 class="modal-title">New Transaction</h5>
                <button type="button" class="btn-close" @click="closeTxnDialog"></button>
                </div>
                <div class="modal-body">
                <!-- Type -->
                <div class="mb-3">
                    <label for="txnType" class="form-label">Transaction Type</label>
                    <select v-model="txnForm.type" class="form-select" id="txnType" required>
                    <option value="">-- Select Type --</option>
                    <option value="add">Add Stock</option>
                    <option value="allocate">Allocate</option>
                    <option value="fulfilment">Fulfilment</option>
                    </select>
                </div>

                <!-- Quantity -->
                <div class="mb-3">
                    <label for="txnQty" class="form-label">Quantity</label>
                    <input
                    v-model.number="txnForm.quantity"
                    type="number"
                    id="txnQty"
                    class="form-control"
                    min="1"
                    required
                    />
                </div>

                <!-- Note -->
                <div class="mb-3">
                    <label for="txnNote" class="form-label">Note (Optional)</label>
                    <textarea
                    v-model="txnForm.note"
                    id="txnNote"
                    rows="3"
                    class="form-control"
                    placeholder="Enter remarks..."
                    ></textarea>
                </div>
                </div>
                <div class="modal-footer">
                <button class="btn btn-secondary" type="button" @click="closeTxnDialog">Cancel</button>
                <button class="btn btn-success" type="submit">Submit</button>
                </div>
            </form>
            </div>
        </div>
    </div>


    <!-- Tabs -->
    <div>
      <!-- Transactions -->
      <div v-if="tab === 'transaction'" class="space-y-6">
        <div class="flex items-center justify-between">
            <h2 class="text-2xl font-semibold">Transaction History</h2>
            <div class="flex gap-2">
                <!-- <button class="btn btn-primary d-flex align-items-center">
                <Plus class="h-4 w-4 mr-2" /> Upload Serial Number
                </button> -->
                <button class="btn btn-primary d-flex align-items-center" @click="openTxnDialog">
                <Plus class="h-4 w-4 mr-2" /> New Transaction
                </button>
            </div>
        </div>

        
        <!-- Date Range Filter -->
        <div class="d-flex gap-3 mt-3">
        <div>
            <label for="startDate" class="form-label text-sm">Start Date</label>
            <input
            type="date"
            id="startDate"
            v-model="startDate"
            class="form-control"
            @change="fetchTransactions"
            />
        </div>
        <div>
            <label for="endDate" class="form-label text-sm">End Date</label>
            <input
            type="date"
            id="endDate"
            v-model="endDate"
            class="form-control"
            @change="fetchTransactions"
            />
        </div>
        </div>

        <div class="border rounded-lg p-4">
            <h3 class="font-semibold mb-2">Recent Transactions</h3>
            <p class="text-sm text-muted-foreground mb-3">
                Track incoming and outgoing stock movements
            </p>

            <!-- Scrollable wrapper -->
            <div class="max-h-96 overflow-y-auto">
                <table class="table table-hover w-full">
                <thead class="sticky top-0 bg-white z-10">
                    <tr>
                    <th>Transaction Type</th>
                    <th>Name</th>
                    <th>Quantity</th>
                    <th>Note</th>
                    <th>Date</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="t in transactions" :key="t.id">
                    <td>
                        <span
                        class="px-2 py-1 rounded-full text-xs"
                        :class="{
                            'bg-green-100 text-green-800': t.type === 'add',
                            'bg-yellow-100 text-yellow-800': t.type === 'allocate',
                            'bg-blue-100 text-blue-800': t.type === 'fulfilment'
                        }"
                        >
                        {{
                            t.type === 'add'
                            ? 'Add Stock'
                            : t.type === 'allocate'
                            ? 'Allocation'
                            : t.type === 'fulfilment'
                            ? 'Fulfilled'
                            : t.type
                        }}
                        </span>
                    </td>
                    <td>{{ t.userName }}</td>
                    <td>{{ t.quantity }}</td>
                    <td>{{ t.note }}</td>
                    <td>{{ formatDateTime(t.createdAt) }}</td>
                    </tr>
                </tbody>
                </table>
            </div>
            </div>

      </div>
    </div>

     
  </div>
  </Layout>
</template>

<script>
import { ArrowLeft, Plus, Package, Clock, CheckCircle } from "lucide-vue-next"
import Layout from '@/components/Layout.vue';
import { useToast } from 'vue-toastification'
import { getAuth, onAuthStateChanged } from "firebase/auth";
import router from "@/router";
import axios from "axios";
export default {
  name: "ProductDetail",
  components: { Layout, ArrowLeft, Plus, Package, Clock, CheckCircle },
  data() {
    return {
        tab: "transaction",
        selectedItem:{},
        userID:"",
        // apiURL: "http://127.0.0.1:5001",
      apiURL: "https://genstoryflow-backend-main-build-353838813175.europe-west1.run.app", 
        startDate: "",
        endDate: "",
        transactions: [],
        productID:this.$route.params.id,
        isTxnDialogOpen: false,
        txnForm: {
            type: "",
            quantity: 1,
            note: ""
        }
    }
  },
  computed: {
  },
    setup() {
        const toast = useToast()

        return {
        toast
        }
    },

    async mounted(){
        this.userID = this.$store.getters.getUserId;
        await this.checkAuthState();
        await this.fetchInventoryItem();
        const today = new Date().toISOString().split("T")[0];
        this.startDate = today;
        this.endDate = today;
        await this.fetchTransactions();
        
    },
    
    methods: {
        goBack() {
            this.$router.push("/inventory")
        },
        openTxnDialog() {
            this.isTxnDialogOpen = true
        },
        closeTxnDialog() {
            this.isTxnDialogOpen = false
            this.txnForm = { type: "", quantity: 1, note: "" } // reset form
        },

        async createTransaction() {
            try {
            const headers = await this.getAuthHeader()
            const payload = {
                itemId: this.productID, // comes from your route param
                type: this.txnForm.type,
                quantity: this.txnForm.quantity,
                note: this.txnForm.note
            }

            const res = await axios.post(`${this.apiURL}/api/inventory/transaction`, payload, { headers })

            if (res.data === "ok") {
                this.toast.success("✅ Transaction created successfully")
                this.closeTxnDialog()
                await this.fetchInventoryItem()   // refresh stats
                await this.fetchTransactions()    // refresh history
            } else {
                this.toast.error("⚠️ Failed to create transaction")
            }
            } catch (err) {
                console.error("❌ Error creating transaction:", err)
                if (err.response && err.response.data && err.response.data.error) {
                    this.toast.error(err.response.data.error)
                } else {
                    this.toast.error("Something went wrong while creating transaction")
                }
            }
        },
        async getAuthHeader() {
            const user = getAuth().currentUser;
            if (!user) throw new Error('Not logged in');
            const token = await user.getIdToken();
            return { Authorization: token };
            },
        async checkAuthState() {
            const auth = getAuth();
            return new Promise((resolve, reject) => {
                onAuthStateChanged(auth, async (user) => {
                if (user) {
                    try {
                    const idToken = await user.getIdToken();
                    this.token = idToken;
                    resolve();
                    } catch (error) {
                    reject(error);
                    }
                } else {
                    router.push("/");
                    reject(new Error("No user logged in"));
                }
                });
            });
        },
        async fetchInventoryItem() {
            try {
                
                const headers = await this.getAuthHeader(); // or use Firebase getIdToken if that’s your flow

                const res = await axios.get(`${this.apiURL}/api/inventory/${this.productID}`, {
                headers
                })

                this.selectedItem = res.data
            } catch (err) {
                this.toast.error("Failed to load inventory item")

            }
        },
        async fetchTransactions() {
            try {
                const headers = await this.getAuthHeader()
                console.log("HERE1")

                // format start/end with full ISO string
                const startISO = new Date(this.startDate).toISOString().split("T")[0] + "T00:00:00"
                const endISO = new Date(this.endDate).toISOString().split("T")[0] + "T23:59:59"
                console.log("HERE")
                const res = await axios.get(`${this.apiURL}/api/inventory/transaction`, {
                    headers,
                    params: {
                    itemId: this.productID,   // <-- from your route param
                    startDate: startISO,
                    endDate: endISO
                    }
                })

                if (res.data && res.data.ok) {
                    this.transactions = res.data.records
                } else {
                    this.toast.error("No transactions found")
                }

                } catch (err) {
                // console.error("❌ Error fetching transactions:", err)
                if (err.response && err.response.data && err.response.data.error) {
                    this.toast.error(err.response.data.error)
                } else {
                    this.toast.error("Something went wrong while fetching transactions")
                }
                }
        },
        formatDateTime(dateTimeString) {
            if (!dateTimeString) return '-';
            const date = new Date(dateTimeString);
            return date.toLocaleString('en-US', {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
            });
        },

  }
}
</script>
